// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./vue2-animate.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("a5ea92c6", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-animate/dist/vue2-animate.min.css
// module id = 15
// module chunks = 0